import React from 'react';

import * as ST from './styled';

interface IProps {
    title: string,
    text?: string,
}

const Headline: React.FC<IProps> = ({ title = 'Heading', text }): JSX.Element => {
    return (<ST.Wrapper data-test='headline'>
        { text && <ST.PreTitleText data-test='headline-title'>{text}</ST.PreTitleText> }
        <ST.Title data-test='headline-text'>{title}</ST.Title>
    </ST.Wrapper>);
};

export default Headline;
